module.exports = __webpack_public_path__ + "static/media/no-image.b675d873.jpg";